import { event } from '@rategravity/frontend/modules/user-actions';
import Immutable from 'immutable';
import React from 'react';
import { Element, scroller } from 'react-scroll';
import Rx from 'rxjs/Rx';
import { piiKeys } from '../../modules/pii-filter';
import { sanitizeModel } from '../../modules/sanitizer';

// Re-export card graph operations
export { Card, Branch, End, percentComplete } from './card-graph';

class EndDeck extends React.Component {
  componentDidMount() {
    this.props.onComplete();
  }

  render() {
    return null;
  }
}

const style = {
  card: {
    margin: '30px 16px'
  }
};

class CardContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    return !(
      this.props.model.equals(nextProps.model) && this.props.overlay.equals(nextProps.overlay)
    );
  }

  render() {
    const model = sanitizeModel(this.props.model.mergeDeep(this.props.overlay));
    return (
      <div style={style.card}>
        {React.cloneElement(this.props.children, { model })}
        <Element name={this.props.name} />
      </div>
    );
  }
}

const stripPii = (overlay) => {
  const filterPii = (m) => m && m.filterNot((_, k) => piiKeys.contains(k));
  return overlay.update('borrower', filterPii).update('coborrower', filterPii);
};

export class Deck extends React.Component {
  constructor(props) {
    super(props);
    // Dedupe question views before sending them on to the action pipe
    this.questionViewPipe = new Rx.Subject().distinctUntilChanged((l, r) =>
      Immutable.fromJS(l).equals(Immutable.fromJS(r))
    );
    this.state = {
      overlay: Immutable.Map()
    };
  }

  componentWillMount() {
    this.subscription = this.questionViewPipe.subscribe(this.props.actionPipe);
  }

  componentDidMount() {
    scroller.scrollTo('bottom', { offset: -100 });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  onCardChange(Card) {
    return (modelKey, prop, value, callback) => {
      this.setState(
        ({ overlay }) => ({
          overlay: overlay.setIn([Card.id, modelKey, prop], value)
        }),
        callback
      );
    };
  }

  renderStaticCard(Card) {
    const overlay = Immutable.Map();
    return (
      <CardContainer
        key={Card.id}
        name={Card.id}
        emailAddress={this.props.model.getIn(['borrower', 'email'])}
        model={this.props.model}
        overlay={overlay}
      >
        <Card onChange={this.onCardChange(Card)} actionPipe={this.props.actionPipe} />
      </CardContainer>
    );
  }

  renderActiveCard(Card) {
    const overlay = this.state.overlay.get(Card.id) || Immutable.Map();
    this.questionViewPipe.next(event('ViewQuestion', { questionId: Card.id }));
    return (
      <CardContainer key={Card.id} name={Card.id} model={this.props.model} overlay={overlay}>
        <Card
          onChange={this.onCardChange(Card)}
          onSubmit={() => {
            const cardOverlay = this.state.overlay.get(Card.id);
            this.props.onSubmit(cardOverlay);
            this.props.actionPipe.next(
              event('SubmitAnswer', {
                questionId: Card.id,
                ...stripPii(cardOverlay).toJS()
              })
            );
            this.setState(
              ({ overlay }) => ({
                overlay: overlay.remove(Card.id)
              }),
              () =>
                scroller.scrollTo(Card.id, {
                  duration: 750,
                  delay: 50,
                  smooth: true,
                  offset: -150
                })
            );
          }}
          actionPipe={this.props.actionPipe}
        />
      </CardContainer>
    );
  }

  render() {
    const cards = Immutable.fromJS(this.props.cardGraph.cards(this.props));
    const staticCards = cards
      .butLast()
      .takeUntil((Card) => this.state.overlay.has(Card.constructor.id));
    const activeCard = cards.skip(staticCards.count()).first();

    const staticElements = staticCards.map((card) => this.renderStaticCard(card.constructor));

    const activeElement =
      activeCard.constructor.id === 'End' ? (
        <EndDeck key="End" onComplete={this.props.onComplete} model={this.props.model} />
      ) : (
        this.renderActiveCard(activeCard.constructor)
      );

    return (
      <div>{staticElements.push(<Element key="bottom" name="bottom" />).concat(activeElement)}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/deck/index.js